import React, { useContext, useState } from "react"
import { LocationsContext } from "store/context/LocationsContext"
import { Eye } from "lucide-react";
import PolygonInfoPopup from "./PolygonInfoPopup";

const SelectedFiltersDisplay: React.FC = () => {
  const { selectedRegion, selectedCommune, selectedCouriers, selectedPolygonType, selectedPolygon } =
    useContext(LocationsContext)

  const [showPolygonInfo, setShowPolygonInfo] = useState(false);

  const handleViewPolygonInfo = () => {
    setShowPolygonInfo(true);
  };

  const filters = [
    { label: "Región", value: selectedRegion },
    { label: "Comuna", value: selectedCommune },
    { label: "Polígono", value: selectedPolygon?.name, isPolygon: true },
    { label: "Tipo de Polígono", value: selectedPolygonType === 'all' ? 'Todos' : selectedPolygonType === 'include' ? 'Inclusión' : selectedPolygonType === 'exclude' ? 'Exclusión' : selectedPolygonType },
    {
      label: "Couriers", value: selectedCouriers?.length ? selectedCouriers.map((c: any) => {
        const idParts = (c.id || "").split('_');
        const identifier = idParts.length > 0 ? idParts[0] : "";
        return `${c.name} (${identifier})`;
      }).join(", ") : null
    },
  ].filter((filter) => filter.value)

  if (filters.length === 0) {
    return null
  }

  return (
    <div className="mt-1  bg-white dark:bg-gray-800 p-4 rounded-lg shadow-md flex flex-wrap gap-3 items-center border border-gray-200 dark:border-gray-700">
      <span className="text-gray-700 dark:text-gray-300 font-semibold text-sm">Filtros Aplicados:</span>
      {filters.map((filter, index) => (
        <span
          key={index}
          className="bg-blue-50 dark:bg-blue-900/20 text-blue-700 dark:text-blue-300 px-3 py-1 rounded-full text-sm font-medium flex items-center gap-1"
        >
          {filter.label}: <span className="font-normal">{filter.value}</span>
          {filter.isPolygon && selectedPolygon && (
            <Eye className="w-4 h-4 ml-1 cursor-pointer text-green-500 hover:text-green-700" onClick={handleViewPolygonInfo} />
          )}
        </span>
      ))}

      {showPolygonInfo && selectedPolygon && (
        <PolygonInfoPopup polygon={selectedPolygon} onClose={() => setShowPolygonInfo(false)} />
      )}
    </div>
  );
}


export default SelectedFiltersDisplay
